import type { Ref } from 'vue';

import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IReviewPaymentSystemPayload } from '../types';
import {
  ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_QUERY_KEY,
  ADMIN_PAYMENT_SYSTEM_DETAILS_PREVIEW_API_URL,
  ADMIN_PAYMENT_SYSTEM_DETAILS_PREVIEW_MUTATION_KEY,
  ADMIN_PAYMENT_SYSTEM_DETAILS_SHOW_QUERY_KEY,
  PAYMENT_SYSTEM_DETAILS_PERMISSIONS,
} from '../constants';

export default function useReviewPaymentSystemMutation(
  rejectionReason: Ref<string | undefined>,
): IContextMutationResult<void, Error, IReviewPaymentSystemPayload> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IReviewPaymentSystemPayload>({
    mutationKey: [ADMIN_PAYMENT_SYSTEM_DETAILS_PREVIEW_MUTATION_KEY],
    mutationFn: ({ actionType, id }) => fetchPost<void>(
      ADMIN_PAYMENT_SYSTEM_DETAILS_PREVIEW_API_URL,
      { rejection_reason: rejectionReason.value },
      {
        permission: PAYMENT_SYSTEM_DETAILS_PERMISSIONS.UPDATE,
        urlParams: {
          id,
          actionType,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_QUERY_KEY] });
      void queryClient.invalidateQueries({ queryKey: [ADMIN_PAYMENT_SYSTEM_DETAILS_SHOW_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
